import React from 'react';
import { getStatusConfig } from '../../lib/appointmentStatus';

interface StatusBadgeProps {
  status: string;
  size?: 'sm' | 'md' | 'lg';
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, size = 'md' }) => {
  const config = getStatusConfig(status);

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-xs px-3 py-1',
    lg: 'text-sm px-4 py-1.5'
  };

  return (
    <span className={`inline-flex items-center rounded-full border font-medium ${config.bg} ${config.color} ${config.border} ${sizeClasses[size]}`}>
      {config.label}
    </span>
  );
};

export default StatusBadge;
